import { IconProps } from './types'

export const EditIcon = ({ size, color }: IconProps) => {
  return (
    <svg
      width={size || '100%'}
      height={size || '100%'}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M9.84006 1.87933L2.05479 9.66466C1.74689 9.97256 1.46095 10.5444 1.39498 10.9622L0.977114 13.9312C0.823168 15.0088 1.57093 15.7566 2.64856 15.6026L5.61755 15.1848C6.03541 15.1188 6.62919 14.8329 6.9151 14.525L14.7004 6.7397C16.042 5.39816 16.6797 3.8367 14.7004 1.85738C12.7431 -0.099944 11.1816 0.537791 9.84006 1.87933Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.71875 3.00195C9.37852 5.37713 11.2259 7.2245 13.6011 7.88427"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
